// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PVbt0","top":"styles_top__X5wWZ","left":"styles_left__3CjYu","description":"styles_description__1gYIp"};